

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMail, FiPhone, FiEdit2, FiTrash2 } from "react-icons/fi";
import "./staff.css";

const StaffPage = () => {
  const [staff, setStaff] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingStaff, setEditingStaff] = useState(null);
  const [newStaff, setNewStaff] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    role: "tstaff",
    status: "active",
  });

  const navigate = useNavigate();

  useEffect(() => {
    fetchStaff();
  }, []);

  const fetchStaff = async () => {
    try {
      const res = await fetch("https://bodhimaram.onrender.com/api/staff");
      const data = await res.json();
      setStaff(data.filter((u) => u.role !== "admin"));
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (e) => {
    setNewStaff({ ...newStaff, [e.target.name]: e.target.value });
  };

  const saveStaff = async () => {
    if (!newStaff.name || !newStaff.email || !newStaff.phone) return;

    try {
      if (editingStaff) {
        await fetch(`https://bodhimaram.onrender.com/api/staff/${editingStaff.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(newStaff),
        });
      } else {
        await fetch("https://bodhimaram.onrender.com/api/staff", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(newStaff),
        });
      }

      setShowModal(false);
      setEditingStaff(null);
      setNewStaff({
        name: "",
        email: "",
        phone: "",
        password: "",
        role: "tstaff",
        status: "active",
      });
      fetchStaff();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = (staffData, e) => {
    e.stopPropagation();
    setEditingStaff(staffData);
    setNewStaff({
      name: staffData.name,
      email: staffData.email,
      phone: staffData.phone,
      password: "",
      role: staffData.role,
      status: staffData.status,
    });
    setShowModal(true);
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Are you sure you want to delete this staff?")) return;

    try {
      await fetch(`https://bodhimaram.onrender.com/api/staff/${id}`, { method: "DELETE" });
      fetchStaff();
    } catch (err) {
      console.error(err);
    }
  };

  const openStaffDetail = (id) => {
    navigate(`/dashboard/staff/${id}`);
  };

  return (
    <div className="staff-container">
      <div className="staff-header">
        <h2>Staff Members</h2>
        <button className="add-staff-btn" onClick={() => setShowModal(true)}>
          + Add Staff
        </button>
      </div>

      <div className="staff-grid">
        {staff.map((s) => (
          <div
            key={s.id}
            className="staff-card universe-card"
            onClick={() => openStaffDetail(s.id)}
          >
            <div className="universe-bg" />

            <div className="universe-header">
              <p  style={{color:"darkblue", fontSize:"25px", fontWeight:"700"}} className="staffnae">{s.name}</p>
         <p   style={{color:"black", fontSize:"15px"}} className="staffroe">
  {s.role === "tstaff" ? "Teacher" : s.role}
</p>

            </div>

            {/* <div className="avatar-box">STAFF</div> */}
<div className="avatar-box">
  <img
    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmvJ14anYdkKq4d0LRhRh0a_u_Kh6DUQGHsQ&s"
    alt="Staff Avatar"
    className="avatar-img"
  />
</div>

            <div className="universe-footer">
              <div className="staff-contact">
                <span className="s-io" ><FiPhone /> {s.phone}</span>
                <span className="s-io" ><FiMail /> {s.email}</span>
              </div>

              <div className="staff-icons">
                <FiEdit2 style={{color:"green"}} onClick={(e) => handleEdit(s, e)} />
                <FiTrash2 style={{color:"red"}} onClick={(e) => handleDelete(s.id, e)} />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal unchanged */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <h3>{editingStaff ? "Edit Staff" : "Add New Staff"}</h3>

            <input name="name" value={newStaff.name} onChange={handleChange} placeholder="Name" />
            <input name="email" value={newStaff.email} onChange={handleChange} placeholder="Email" />
            <input name="phone" value={newStaff.phone} onChange={handleChange} placeholder="Phone" />

            {!editingStaff && (
              <input
                type="password"
                name="password"
                value={newStaff.password}
                onChange={handleChange}
                placeholder="Password"
              />
            )}

            <select name="role" value={newStaff.role} onChange={handleChange}>
              <option value="tstaff">Teaching Staff</option>
              <option value="mstaff">Management Staff</option>
              <option value="tmstaff">Both</option>
            </select>

            <select name="status" value={newStaff.status} onChange={handleChange}>
              <option value="active">Active</option>
              <option value="deactive">Deactive</option>
            </select>

            <div className="modal-actions">
              <button className="cancel-btn" onClick={() => setShowModal(false)}>Cancel</button>
              <button className="save-btn" onClick={saveStaff}>
                {editingStaff ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StaffPage;
